export const BANNER_LIST = "BANNER_LIST";
export const BANNER_LIST_FAILED = "BANNER_LIST_FAILED";
export const BANNER_LIST_SUCCESS = "BANNER_LIST_SUCCESS";
